import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type ITransferPhoneNumberMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  toUserId: Types.Scalars['ObjectId']['input']
  phoneNumber: Types.Scalars['String']['input']
  confirmStrandSource?: Types.InputMaybe<Types.Scalars['Boolean']['input']>
  confirmReplaceTarget?: Types.InputMaybe<Types.Scalars['Boolean']['input']>
}>

export type ITransferPhoneNumberMutation = {
  transferPhoneNumber?: {
    success: boolean
    requiresConfirmation: boolean
    confirmationReason?: string | null
    message?: string | null
    phoneNumber?: string | null
    status?: string | null
  } | null
}

export type IRemovePhoneNumberMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  userId: Types.Scalars['ObjectId']['input']
  confirmStrandSource?: Types.InputMaybe<Types.Scalars['Boolean']['input']>
}>

export type IRemovePhoneNumberMutation = {
  removePhoneNumber?: {
    success: boolean
    requiresConfirmation: boolean
    confirmationReason?: string | null
    message?: string | null
    phoneNumber?: string | null
    status?: string | null
  } | null
}

export type IPhoneActivityLogQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  phoneNumber: Types.Scalars['String']['input']
}>

export type IPhoneActivityLogQuery = {
  phoneActivityLogs?: Array<{
    changeType?: string | null
    status?: string | null
    occurredAt: any
    phoneNumber?: string | null
    direction?: string | null
    replacedNumber?: string | null
    subjectName?: string | null
    subjectUserId?: string | null
    counterpartyName?: string | null
    counterpartyUserId?: string | null
    initiatorTenantHost?: string | null
    isSystem: boolean
  } | null> | null
}

export const TransferPhoneNumberDocument = gql`
  mutation TransferPhoneNumber(
    $projectId: ObjectId!
    $toUserId: ObjectId!
    $phoneNumber: String!
    $confirmStrandSource: Boolean
    $confirmReplaceTarget: Boolean
  ) {
    transferPhoneNumber(
      projectId: $projectId
      toUserId: $toUserId
      phoneNumber: $phoneNumber
      confirmStrandSource: $confirmStrandSource
      confirmReplaceTarget: $confirmReplaceTarget
    ) {
      success
      requiresConfirmation
      confirmationReason
      message
      phoneNumber
      status
    }
  }
`
export type ITransferPhoneNumberMutationFn = Apollo.MutationFunction<
  ITransferPhoneNumberMutation,
  ITransferPhoneNumberMutationVariables
>

/**
 * __useTransferPhoneNumberMutation__
 *
 * To run a mutation, you first call `useTransferPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferPhoneNumberMutation, { data, loading, error }] = useTransferPhoneNumberMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      toUserId: // value for 'toUserId'
 *      phoneNumber: // value for 'phoneNumber'
 *      confirmStrandSource: // value for 'confirmStrandSource'
 *      confirmReplaceTarget: // value for 'confirmReplaceTarget'
 *   },
 * });
 */
export function useTransferPhoneNumberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ITransferPhoneNumberMutation,
    ITransferPhoneNumberMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ITransferPhoneNumberMutation,
    ITransferPhoneNumberMutationVariables
  >(TransferPhoneNumberDocument, options)
}
export type TransferPhoneNumberMutationHookResult = ReturnType<
  typeof useTransferPhoneNumberMutation
>
export type TransferPhoneNumberMutationResult =
  Apollo.MutationResult<ITransferPhoneNumberMutation>
export type TransferPhoneNumberMutationOptions = Apollo.BaseMutationOptions<
  ITransferPhoneNumberMutation,
  ITransferPhoneNumberMutationVariables
>
export const RemovePhoneNumberDocument = gql`
  mutation RemovePhoneNumber(
    $projectId: ObjectId!
    $userId: ObjectId!
    $confirmStrandSource: Boolean
  ) {
    removePhoneNumber(
      projectId: $projectId
      userId: $userId
      confirmStrandSource: $confirmStrandSource
    ) {
      success
      requiresConfirmation
      confirmationReason
      message
      phoneNumber
      status
    }
  }
`
export type IRemovePhoneNumberMutationFn = Apollo.MutationFunction<
  IRemovePhoneNumberMutation,
  IRemovePhoneNumberMutationVariables
>

/**
 * __useRemovePhoneNumberMutation__
 *
 * To run a mutation, you first call `useRemovePhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePhoneNumberMutation, { data, loading, error }] = useRemovePhoneNumberMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      userId: // value for 'userId'
 *      confirmStrandSource: // value for 'confirmStrandSource'
 *   },
 * });
 */
export function useRemovePhoneNumberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IRemovePhoneNumberMutation,
    IRemovePhoneNumberMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IRemovePhoneNumberMutation,
    IRemovePhoneNumberMutationVariables
  >(RemovePhoneNumberDocument, options)
}
export type RemovePhoneNumberMutationHookResult = ReturnType<
  typeof useRemovePhoneNumberMutation
>
export type RemovePhoneNumberMutationResult =
  Apollo.MutationResult<IRemovePhoneNumberMutation>
export type RemovePhoneNumberMutationOptions = Apollo.BaseMutationOptions<
  IRemovePhoneNumberMutation,
  IRemovePhoneNumberMutationVariables
>
export const PhoneActivityLogDocument = gql`
  query PhoneActivityLog($projectId: ObjectId!, $phoneNumber: String!) {
    phoneActivityLogs(projectId: $projectId, phoneNumber: $phoneNumber) {
      changeType
      status
      occurredAt
      phoneNumber
      direction
      replacedNumber
      subjectName
      subjectUserId
      counterpartyName
      counterpartyUserId
      initiatorTenantHost
      isSystem
    }
  }
`

/**
 * __usePhoneActivityLogQuery__
 *
 * To run a query within a React component, call `usePhoneActivityLogQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhoneActivityLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhoneActivityLogQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function usePhoneActivityLogQuery(
  baseOptions: Apollo.QueryHookOptions<
    IPhoneActivityLogQuery,
    IPhoneActivityLogQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IPhoneActivityLogQuery,
    IPhoneActivityLogQueryVariables
  >(PhoneActivityLogDocument, options)
}
export function usePhoneActivityLogLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IPhoneActivityLogQuery,
    IPhoneActivityLogQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IPhoneActivityLogQuery,
    IPhoneActivityLogQueryVariables
  >(PhoneActivityLogDocument, options)
}
export type PhoneActivityLogQueryHookResult = ReturnType<
  typeof usePhoneActivityLogQuery
>
export type PhoneActivityLogLazyQueryHookResult = ReturnType<
  typeof usePhoneActivityLogLazyQuery
>
export type PhoneActivityLogQueryResult = Apollo.QueryResult<
  IPhoneActivityLogQuery,
  IPhoneActivityLogQueryVariables
>
